import { FC } from 'react';
import classNames from 'classnames';
import COUNTRIES_CODE from '../../constants/countriesCode';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import './Player.scss';

interface IPlayer {
  visible: boolean;
  hasTurn: boolean;
  avatarId: number;
  name: string;
  suffix: string;
  isWhite: boolean;
  piecesCaptured: number;
  isRed: boolean;
  countryCode: string;
  eloRating: number;
}

export const Player: FC<IPlayer> = ({
  visible,
  hasTurn,
  avatarId,
  name,
  suffix,
  isWhite,
  piecesCaptured,
  isRed,
  countryCode,
  eloRating,
}) => (
  <div className={classNames('player', { active: hasTurn, hidden: !visible })}>
    <div className={classNames('avatar', 'player-avatar', 'a-' + avatarId)} />

    {countryCode && (
      <Tippy
        content={
          countryCode !== 'RU' && COUNTRIES_CODE[countryCode]
            ? COUNTRIES_CODE[countryCode]
            : ''
        }
      >
        <span
          className={classNames(
            'player-country',
            'fi',
            'fi-' + countryCode.toLowerCase(),
          )}
        ></span>
      </Tippy>
    )}

    <div className="player-name">
      {name}
      {suffix && <span className="player-suffix"> {suffix}</span>}
    </div>

    {eloRating && (
      <Tippy content="ELO rating">
        <div className="player-rating">{eloRating}</div>
      </Tippy>
    )}

    {!!piecesCaptured && (
      <div
        className={classNames(
          'player-captured',
          { black: isWhite },
          { red: isWhite && isRed },
        )}
      >
        x{piecesCaptured}
      </div>
    )}
  </div>
);

export default Player;
